/*
 * Copyright (c) 2020. American Express Company
 */

import * as _ from 'lodash';

export default class SessionStorageService {
    public static sessionStorageSupported: boolean =
        typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined' && window.sessionStorage != null;

    public static get(key: string): string | null {
        if (this.sessionStorageSupported) {
            return sessionStorage.getItem(key);
        } else {
            this.unsupportedError();
            return null;
        }
    }

    public static set(key: string, item: string): boolean {
        if (this.sessionStorageSupported) {
            sessionStorage.setItem(key, item);
            return true;
        } else {
            this.unsupportedError();
            return false;
        }
    }

    public static remove(key: string): void {
        sessionStorage.removeItem(key);
    }

    private static unsupportedError(): void {
        console.error('SessionStorage is not supported in this browser.');
    }

    public static clear(): void {
        sessionStorage.clear();
    }

    public static keys(): string[] {
        return _.range(sessionStorage.length).map((i) => sessionStorage.key(i));
    }
}
